import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class TtvpnDetailReportService extends Service {
    constructor() {
        super();
        this.baseURL = 'ttvpnDetailReport';
    }

    findTemosByMonth(month) {
        return fetch(SERVER_URL + this.baseURL + '/' + month, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}